import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./SharedContextStore/store";
import { setupBannerMock } from "./SharedContextStore/bannerMock";

setupBannerMock(store);

const PERF_TAG = "%c[PERF]";
const PERF_STYLE = "background:#fa783c;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold;";

const fmt = (ms: number) => `${ms.toFixed(0)} ms (${(ms / 1000).toFixed(2)} s)`;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

performance.mark("react-render-start");
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
performance.mark("react-render-end");
performance.measure("react initial render", "react-render-start", "react-render-end");

const reactRender = performance.getEntriesByName("react initial render")[0];
console.log(PERF_TAG, PERF_STYLE, `React initial render call: ${fmt(reactRender.duration)}`);

window.addEventListener("load", () => {
  const nav = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming | undefined;
  if (nav) {
    console.log(PERF_TAG, PERF_STYLE, `TTFB (server response):     ${fmt(nav.responseStart - nav.requestStart)}`);
    console.log(PERF_TAG, PERF_STYLE, `DOM Content Loaded:         ${fmt(nav.domContentLoadedEventEnd)}`);
    console.log(PERF_TAG, PERF_STYLE, `DOM Complete:               ${fmt(nav.domComplete)}`);
    console.log(PERF_TAG, PERF_STYLE, `Window Load event:          ${fmt(nav.loadEventEnd)}`);
    console.log(PERF_TAG, PERF_STYLE, `Total page load:            ${fmt(nav.loadEventEnd - nav.startTime)}`);
  }
  const paints = performance.getEntriesByType("paint");
  paints.forEach((p) => {
    console.log(PERF_TAG, PERF_STYLE, `${p.name.padEnd(28)}${fmt(p.startTime)}`);
  });
});

reportWebVitals((metric) => {
  console.log(
    PERF_TAG,
    PERF_STYLE,
    `${metric.name.padEnd(28)}${fmt(metric.value)}  (rating: ${(metric as any).rating ?? "n/a"})`
  );
});